module.exports = __webpack_public_path__ + "images/emoji/chart_with_upwards_trend.bf650005cbfa924b6213.png";